import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BudgetFormGroup } from '../models/budget.model';

export const BudgetsFormHelpers = {
    createBudgetFormGroup
};

function createBudgetFormGroup(
    fiscalYear: number,
    amount: number | null = null,
    id: string | null = null
): BudgetFormGroup {
    return new FormGroup({
        id: new FormControl<string | null>(id),
        fiscalYear: new FormControl(fiscalYear, { nonNullable: true }),
        amount: new FormControl<number | null>(amount, {
            validators: [Validators.required, Validators.min(0)]
        })
    });
}
